import bagel01 from '../data/img/bagels/sesame-bagel.png';
import bagel02 from '../data/img/bagels/cheese-bagel.png';
import bagel03 from '../data/img/bagels/plainbagel.png';
import bagel04 from '../data/img/bagels/everything.png';
import bagel05 from '../data/img/bagels/blue-bagel.png';
import bagel06 from '../data/img/bagels/wholewheat-bagel.png';
import bagel07 from '../data/img/bagels/montreal-style-bagel-sandwich.png';
import bagel08 from '../data/img/bagels/ham&cheese-bagel-sandwich.png';

const bagelImg = [
  { name: 'Sesame Bagel', src: bagel01, alt: 'sesame bagel' },
  { name: 'Cheese Bagel', src: bagel02, alt: 'cheese bagel' },
  { name: 'Plain Bagel', src: bagel03, alt: 'plain bagel' },
  { name: 'Everything Bagel', src: bagel04, alt: 'everything bagel' },
  { name: 'Blueberry Bagel', src: bagel05, alt: 'blueberry bagel' },
  { name: 'Wholewheat Bagel', src: bagel06, alt: 'wholewheat bagel' },
  { name: 'Montreal Style Bagel', src: bagel07, alt: 'montreal style bagel' },
  { name: 'Ham & Cheese Bagel', src: bagel08, alt: 'ham & cheese bagel' },
];

export default bagelImg;
